import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent } from '../shared/component/dynamic-form/dialog-box/dialog-component';
import { LoginRepository } from '../shared/repositories/login.repository';
import { LoginService } from '../shared/services/login.service';
import { LoginComponent } from './login.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { PasswordRecoveryRepository } from './password-recovery/repositories/password-recovery.repository';
import { PasswordRecoveryService } from './password-recovery/services/password-recovery.service';
import { PasswordResetComponent } from './password-reset/password-reset.component';
@NgModule({
  declarations: [LoginComponent, PasswordRecoveryComponent, DialogComponent, PasswordResetComponent],
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, MatSnackBarModule, MatDialogModule, TranslateModule],
  providers: [
    LoginService,
    LoginRepository,
    PasswordRecoveryService,
    PasswordRecoveryRepository,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class LoginModule {}
